import React, { ReactNode, memo } from 'react';
import isEmpty from 'lodash/isEmpty';

import {
  OperationUUID,
  FetchOperationsCacheKeys,
  FetchOperationsShowOperation
} from '../../../operationsTypes';
import { TeamNanoID } from '../../../../teams/teamsTypes';
import { UserID } from '../../../../users/usersTypes';
import { CompanyOperationsCompactTableBodyOperations } from './CompanyOperationsCompactTableBody.types';
import { UpdateOperationModalButtonAccess } from '../../../components/modalButtons/UpdateOperationModalButton';

import { IndexTableBody } from '../../../../common/components/tables/IndexTableBody';

import { CompanyOperationsCompactTableRow } from '../CompanyOperationsCompactTableRow';

interface CompanyOperationsCompactTableBodyProps {
  operations: CompanyOperationsCompactTableBodyOperations;
  clientsIds?: UserID[];
  teamNanoId?: TeamNanoID;
  cacheKeys?: FetchOperationsCacheKeys;
  noOperationsTableRow?: ReactNode;
  withUpdateButton?: boolean;
  updateButtonAccess: UpdateOperationModalButtonAccess;
  selectedOperationUuid?: OperationUUID;
  onOperationShow?: FetchOperationsShowOperation;
  onOperationShowMouseOver?: FetchOperationsShowOperation;
}

function CompanyOperationsCompactTableBody({
  operations,
  clientsIds,
  teamNanoId,
  cacheKeys,
  noOperationsTableRow,
  withUpdateButton,
  updateButtonAccess,
  selectedOperationUuid,
  onOperationShow,
  onOperationShowMouseOver
}: CompanyOperationsCompactTableBodyProps) {
  return (
    <IndexTableBody>
      {operations.map((operation) => (
        <CompanyOperationsCompactTableRow
          key={operation.uuid}
          operation={operation}
          clientsIds={clientsIds}
          teamNanoId={teamNanoId}
          cacheKeys={cacheKeys}
          withUpdateButton={withUpdateButton}
          updateButtonAccess={updateButtonAccess}
          selectedOperationUuid={selectedOperationUuid}
          onOperationShow={onOperationShow}
          onOperationShowMouseOver={onOperationShowMouseOver}
        />
      ))}

      {isEmpty(operations) && noOperationsTableRow}
    </IndexTableBody>
  );
}

export default memo(CompanyOperationsCompactTableBody);
